"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxLabel = exports.Checkbox = exports.Input = exports.CheckboxContainer = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Layout = require("../../../../Layout");

var _Label = _interopRequireDefault(require("../../Label"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CheckboxContainer = (0, _styledComponents.default)(_Layout.Flex)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  cursor: pointer;\n  position: relative;\n\n  & input[type=\"checkbox\"] + div > svg {\n    display: none;\n  }\n\n  & input[type=\"checkbox\"]:checked + div > svg {\n    display: block;\n  }\n\n  :focus-visible {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n"], ["\n  cursor: pointer;\n  position: relative;\n\n  & input[type=\"checkbox\"] + div > svg {\n    display: none;\n  }\n\n  & input[type=\"checkbox\"]:checked + div > svg {\n    display: block;\n  }\n\n  :focus-visible {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.black;
});
exports.CheckboxContainer = CheckboxContainer;
CheckboxContainer.displayName = 'CheckboxContainer';
CheckboxContainer.defaultProps = {
  mx: '0',
  my: '1'
};

var Input = _styledComponents.default.input(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  opacity: 0;\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n\n  :focus ~ label {\n    outline: 1px dotted ", ";\n    outline-offset: 2px;\n  }\n\n  :focus-visible ~ label {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n"], ["\n  opacity: 0;\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n\n  :focus ~ label {\n    outline: 1px dotted ", ";\n    outline-offset: 2px;\n  }\n\n  :focus-visible ~ label {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors['slate-grey'];
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.black;
});

exports.Input = Input;
Input.displayName = 'Input';
var Checkbox = (0, _styledComponents.default)(_Layout.Flex)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  position: absolute;\n  border: 2px solid rgba(0, 0, 0, 0.54);\n  border-radius: 2px;\n  width: 18px;\n  height: 18px;\n  font-weight: bold;\n"], ["\n  position: absolute;\n  border: 2px solid rgba(0, 0, 0, 0.54);\n  border-radius: 2px;\n  width: 18px;\n  height: 18px;\n  font-weight: bold;\n"])));
exports.Checkbox = Checkbox;
var CheckboxLabel = (0, _styledComponents.default)(_Label.default)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  position: relative;\n  padding-left: 26px;\n  line-height: 1.4;\n"], ["\n  position: relative;\n  padding-left: 26px;\n  line-height: 1.4;\n"])));
exports.CheckboxLabel = CheckboxLabel;
CheckboxLabel.displayName = 'CheckboxLabel';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;